
export default function FormatPrice({price}) {
  return Intl.NumberFormat("en-IN", {
    style:"currency",
    currency:"INR",
    maximumFractionDigits:2
  }).format(price)
}
